"use client";

import DatePickerComponent from "../../../../components/DatePicker";
import Dropdown from "../../../../components/Dropdown";
import FormInput from "../../../../components/FormInput";
import Button from "../../../../components/Button";
import DrugSearchInputClean from "../../Recieve Stock/components/DrugSearchInputClean.jsx";
import { searchStockRequestInventory } from "../../../../api/Inventory/StockRequestApi";
import StockAvailabilityPill from "../../../../components/StockAvailabilityPill.jsx";
import detailStyles from "../../css/inventoryItemDetail.module.css";
import layoutStyles from "../css/stockRequestComponents.module.css";
import StockRequestNoteRow from "./StockRequestNoteRow.jsx";
import StockRequestQuantityRow from "./StockRequestQuantityRow.jsx";

// Helper: format yyyy-mm-dd to dd/mm/yyyy for UI display only
const formatDateDMY = (yyyyMmDd) => {
  const s = String(yyyyMmDd || '').trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return s;
  return `${m[3]}/${m[2]}/${m[1]}`;
};

export default function StockRequestClinicForm({
  isRequestFlow,
  selectedRow,
  activeSegment,
  branchOptions,
  branchDisplay,
  setBranchDisplay,
  sku,
  setSku,
  barcode,
  setBarcode,
  strength,
  setStrength,
  packSize,
  setPackSize,
  cost,
  setCost,
  expiryDate,
  setExpiryDate,
  dateRequested,
  setDateRequested,
  requestedBy,
  setRequestedBy,
  note,
  setNote,
  quantity,
  setQuantity,
  onSubmitRequest,
  productName,
  handleProductSelect,
  stockQty,
  showStockPill,
  onHideStockPill,
}) {
  return (
    <>
      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Branch</label>
          {isRequestFlow ? (
            <>
              <Dropdown
                options={branchOptions}
                value={branchDisplay || ""}
                onChange={setBranchDisplay}
              />
              {showStockPill && stockQty != null && (
                <StockAvailabilityPill
                  quantity={stockQty}
                  onClose={onHideStockPill}
                />
              )}
            </>
          ) : (
            <FormInput
              label=""
              type="text"
              name="clinicBranchView"
              value={selectedRow?.transferTo || branchDisplay || branchOptions[0] || ""}
              onChange={() => {}}
              readOnly
            />
          )}
        </div>
        <div className={detailStyles.field}>
          <label>Items  Name</label>
          {isRequestFlow ? (
            <DrugSearchInputClean
              id="stock-request-product-clinic"
              initialValue={productName}
              placeholder="Search medication"
              productType="Drug"
              department={activeSegment}
              searchBackend={async (term) => {
                const results = await searchStockRequestInventory("Drug", term, activeSegment);
                return (Array.isArray(results) ? results : []).map((r) => {
                  const { quantity, ...rest } = r || {};
                  return rest;
                });
              }}
              getDisplayValue={(m) => m?.name || ""}
              onSelect={handleProductSelect}
            />
          ) : (
            <FormInput
              label=""
              type="text"
              name="clinicProductNameView"
              value={selectedRow?.drugName || productName || ""}
              onChange={() => {}}
              readOnly
            />
          )}
        </div>
      </div>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <FormInput
            label="SKU"
            type="text"
            name="skuClinic"
            value={isRequestFlow ? sku : selectedRow?.sku || ""}
            onChange={isRequestFlow ? (e) => setSku(e.target.value) : () => {}}
          />
        </div>
        <div className={detailStyles.field}>
          <FormInput
            label="Bar code"
            type="text"
            name="barcode"
            value={isRequestFlow ? barcode : selectedRow?.barcode || ""}
            onChange={isRequestFlow ? (e) => setBarcode(e.target.value) : () => {}}
          />
        </div>
      </div>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <FormInput
            label="Strength"
            type="text"
            name="strengthClinic"
            value={isRequestFlow ? strength : selectedRow?.strength || ""}
            onChange={isRequestFlow ? (e) => setStrength(e.target.value) : () => {}}
          />
        </div>
        <div className={detailStyles.field}>
          <FormInput
            label="Pack Size"
            type="text"
            name="packSizeClinic"
            value={
              isRequestFlow
                ? packSize
                : selectedRow?.packSize != null
                ? String(selectedRow.packSize)
                : ""
            }
            onChange={isRequestFlow ? (e) => setPackSize(e.target.value) : () => {}}
          />
        </div>
      </div>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <FormInput
            label="Cost"
            type="text"
            name="costClinic"
            value={
              isRequestFlow
                ? cost
                : selectedRow?.costPrice != null
                ? String(selectedRow.costPrice)
                : ""
            }
            onChange={isRequestFlow ? (e) => setCost(e.target.value) : () => {}}
          />
        </div>
        <div className={detailStyles.field}>
          <label>Expiry Date</label>
          {isRequestFlow ? (
            <FormInput
              label=""
              type="date"
              name="clinicExpiryDate"
              value={
                expiryDate instanceof Date
                  ? expiryDate.toISOString().slice(0, 10)
                  : expiryDate || ""
              }
              onChange={(e) => {
                const val = e.target.value;
                setExpiryDate(val ? new Date(val) : null);
              }}
            />
          ) : (
            <FormInput
              label=""
              type="text"
              name="clinicExpiryDateView"
              value={selectedRow?.expiryDate || ""}
              onChange={() => {}}
              readOnly
            />
          )}
        </div>
      </div>

      <hr className={detailStyles.divider} />

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Date Requested</label>
          {isRequestFlow ? (
            <FormInput
              label=""
              type="date"
              name="clinicDateRequested"
              min={new Date().toISOString().split('T')[0]}
              value={
                dateRequested instanceof Date
                  ? dateRequested.toISOString().slice(0, 10)
                  : dateRequested || ""
              }
              onChange={(e) => {
                const val = e.target.value;
                setDateRequested(val ? new Date(val) : null);
              }}
            />
          ) : (
            <FormInput
              label=""
              type="text"
              name="clinicDateRequestedView"
              value={formatDateDMY(selectedRow?.requestDate || "")}
              onChange={() => {}}
              readOnly
            />
          )}
        </div>
        <div className={detailStyles.field}>
          <label>Requested By</label>
          {isRequestFlow ? (
            <FormInput
              label=""
              type="text"
              name="requestedByClinic"
              value={requestedBy}
              onChange={(e) => setRequestedBy(e.target.value)}
            />
          ) : (
            <FormInput
              label=""
              type="text"
              name="requestedByClinicView"
              value={selectedRow?.requestedByName || ""}
              onChange={() => {}}
            />
          )}
        </div>
      </div>

      <StockRequestNoteRow note={note} setNote={setNote} readOnly={!isRequestFlow} />

      <StockRequestQuantityRow
        isRequestFlow={isRequestFlow}
        quantity={quantity}
        setQuantity={setQuantity}
        viewValue={selectedRow?.requestedQty}
        viewName="quantityClinicView"
      />

      {isRequestFlow && (
        <div className={layoutStyles.modalSingleActionRow}>
          <Button
            type="button"
            variant="primary"
            onClick={() => {
              if (onSubmitRequest)
                onSubmitRequest({
                  sku,
                  name: productName,
                  quantity,
                  toBranchDisplay: branchDisplay,
                  note,
                });
            }}
          >
            Submit
          </Button>
        </div>
      )}
    </>
  );
}
